export default __webpack_public_path__ + "static/media/oasis.ce26fd09.png";